export class PathAdditions {
  public dimensionPathAddition: string[] = ['height', 'width', 'depth'];
  public addressPathAddition: string[] = ['country', 'zipcode', 'location', 'street', 'street_addition'];
}
